import React from 'react'
import {
    Chart as ChartJS,
    LineElement,
    LineController,
    BarElement,
    BarController,
    PointElement,
    LinearScale,
    CategoryScale,
    Legend,
    Tooltip,
    Title,
} from 'chart.js'
import { Chart } from 'react-chartjs-2'


ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    BarController,
    LineController,
    Title,
);

export type typeOptions = {
    plugins: {
        title?: {
            display: boolean,
            text: string,
        },
        legend?: {
            display: boolean,
            position: string,
        },
        tooltip: {
            enabled: boolean,
            position: string,
            backgroundColor: string,
            titleColor: string,
            bodyColor: string,
            borderColor: string,
            borderWidth: number,
            displayColors: boolean,
        }
    },
    responsive: boolean,
    maintainAspectRatio?: boolean,
    interaction: {
        mode: string,
        axis: string,
        intersect: boolean,
    },
    scales: {
        x: {
            stacked: boolean,
        },
        y: {
            stacked: boolean,
        },
    },
}

type typeDataBar = {
    labels: string[],
    datasets: {
        type?: string,
        label: string,
        data: number[],
        backgroundColor: string,
        borderWidth?: number,
        fill?: boolean,
        borderColor?: string,
        pointRadius?: number,
        pointHoverRadius?: number,
        stack?: string,
    }[],
}

export type typeData = {
    labels: string[],
    datasets: {
        label: string,
        data: number[],
    }[]
}

const totalOptions: typeOptions = {
    plugins: {
        legend: {
            display: true,
            position: 'bottom' as const,
        },
        tooltip: {
            enabled: true,
            position: 'nearest',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            titleColor: '#333',
            bodyColor: '#333',
            borderColor: 'rgba(0, 0, 0, 0.1)',
            borderWidth: 1,
            displayColors: true,
        },
    },
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
}

const colors = ['#65855e', '#adbca9', '#d6ded4', '#eaefe9', '#f6f8f5']
const lineColor = '#516e4b'


export type typeBar = {
    amountTitle?: string,
    legend?: boolean,
    data: typeData,
}

export const BarChart: React.FC<typeBar> = ({amountTitle, data, legend= true}) => {

    const totalData: typeDataBar = {
        labels: data.labels,
        datasets: data.datasets.map((item, index) => {
            return {
                type: 'bar' as const,
                label: item.label,
                data: item.data,
                backgroundColor: index < colors.length ? colors[index] : colors[colors.length - 1],
                stack: 'Stack 0',
            }
        })
    }

    if (amountTitle) {

        let maxLength = 0

        data.datasets.forEach((item) => {
            if (maxLength < item.data.length) {
                maxLength = item.data.length
            }
        })

        const totalDataArray = []
        const arraysCount = data.datasets.length
        for (let index = 0; index < maxLength; index++) {
            let totalValue = 0
            for (let j = 0; j < arraysCount; j++) {
                totalValue += data.datasets[j].data[index] ? data.datasets[j].data[index] : 0
            }
            totalDataArray.push(totalValue)
        }

        totalData.datasets.unshift({
            type: 'line' as const,
            label: amountTitle,
            data: totalDataArray,
            backgroundColor: '#fff',
            borderWidth: 1,
            fill: true,
            borderColor: lineColor,
            pointRadius: 3,
            pointHoverRadius: 6,
        })
    }

    const options = legend
        ? totalOptions
        : {
            ...totalOptions,
            ...{
                plugins: {
                    legend: { display: false }
                }
            }
    }

    return(<>
        {/* @ts-ignore */}
        <Chart options={options} data={totalData} />
    </>)
}